export default {
  validate: function (value) {
    return /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,12}$/.test(value)
  }
}



// WEBPACK FOOTER //
// ./src/config/validate/rules/password.js